<template>
  <div>
    <md-dialog :md-active.sync="showDialog" v-on:md-closed="closed" >
      <div class="content-dialog">
        <div class="loading-overlay" v-if="!loadDialog">
          <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <md-dialog-title>Редактирование</md-dialog-title>
        <form novalidate class="md-layout" @submit.prevent="validateUser">
          <md-card class="md-layout-item">
            <md-card-content>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('id')">
                    <label for="id">Номер заяви</label>
                    <md-input name="id" id="id" autocomplete="given-name" v-model="form.id"
                              disabled="disabled"/>
                  </md-field>
                </div>

                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('city')">
                    <label for="city">Город</label>
                    <md-input name="city" id="city" autocomplete="family-name" v-model="form.city"
                              disabled="disabled"/>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('name')">
                    <label for="name">ФИО</label>
                    <md-input name="name" id="name" autocomplete="family-name" v-model="form.name"
                              disabled="disabled"/>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('phone')">
                    <label for="phone">Номер телефона</label>
                    <md-input name="phone" id="phone" autocomplete="family-name" v-model="form.phone"
                              disabled="disabled"/>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field>
                    <label for="created">Дата создания</label>
                    <md-input name="created" id="created" autocomplete="family-name" disabled="disabled"
                              v-model="form.create"/>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field>
                    <label for="updated">Дата изменения</label>
                    <md-input name="updated" id="updated" autocomplete="family-name" disabled="disabled"
                              v-model="form.update"/>
                  </md-field>
                </div>
              </div>

              <md-field>
                <label for="status">Статус</label>
                <md-select v-model="form.status" name="status" id="status" :disabled="isDisabled()">
                  <md-option value="0" :key="'status_1'">Новая</md-option>
                  <md-option value="1" :key="'status_2'">Выполнено</md-option>
                  <md-option value="-1" :key="'status_3'">Отклонено</md-option>
                </md-select>
              </md-field>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field>
                    <label for="comment">Комментарий</label>
                    <md-textarea name="comment" id="comment" autocomplete="family-name" :disabled="isDisabled()"
                                 v-model="form.comment" maxlength="400"/>
                  </md-field>
                </div>
              </div>

            </md-card-content>
          </md-card>
        </form>
        <md-dialog-actions>

          <md-button class="md-primary  ct-yellow pointer" @click="closed()">Закрыть</md-button>
          <md-button class="md-primary  ct-green pointer" @click="submitForm" v-if="!isDisabled()">Сохранить</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>import {validationMixin} from 'vuelidate'
import HttpClient from '@/api/calls'
import store from '@/store'
import FormatDate from '@/format/date'
export default {
  name: 'DialogCustomReq',
  mixins: [validationMixin],
  data: () => ({
    form: {
      id: null,
      name: null,
      tin: null,
      status: null,
      comment: null,
      create: null,
      update: null,
      working_hours_to: null,
      city_id: null
    },
    sending: false,
    showDialog: false,
    loadDialog: false,
    userData: {},
    successSave: false,
    err: false
  }),
  validations: {
    form: {}
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    dateFormat (str) {
      return FormatDate.format(str)
    },
    submitForm () {
      this.startLoading()
      for (let i in this.form) {
        this.userData[i] = this.form[i]
      }
      this.successSave = true
      HttpClient.httpPatch(['requests.edit', this.$store.state.editID], this.userData)
        .then(resp => {
          this.err = resp
          this.stopLoading()
        })
        .catch(err => {
          this.err = err
          this.stopLoading()
        })
    },
    setUserInfo (response) {
      for (let key in response.data[0]) {
        if (key === 'status') {
          response.data[0][key] = response.data[0][key]['id']
        }
        if (key === 'create' || key === 'update') {
          response.data[0][key] = this.dateFormat(response.data[0][key])
        }
        this.form[key] = response.data[0][key]
      }
      this.userData = response.data[0]
    },
    getEditData () {
      this.startLoading()
      let filter = {'country_code': store.getters.regionUser}
      return HttpClient.httpGet(['requests.getById', this.$store.state.editID], filter)
    },
    startLoading () {
      this.loadDialog = false
    },
    stopLoading () {
      this.loadDialog = true
    },
    isDisabled () {
      if (this.userData.status === 0) {
        return false
      } else {
        return true
      }
    },
    closed () {
      this.showDialog = false
      if (this.successSave === true) {
        this.$emit('closeDialogSuccess')
      } else {
        this.$emit('closeDialog')
      }
      this.successSave = false
    }
  },
  async created () {
    this.startLoading()
    if (!this.$store.state.editID) {
      this.showDialog = false
      return false
    }
    this.showDialog = true
    const $thisReq = this
    let response = await Promise.all([$thisReq.getEditData()])
    this.setUserInfo(response[0])
    this.stopLoading()
  }
}
</script>

<style lang="scss" scoped>
  .md-dialog {
    max-width: 830px;
    min-height: 450px;
    overflow: auto;
  }

  .loading-overlay {
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 450px;
    background: none;
    position: absolute;
    z-index: 9;
  }

  .md-button.ct-green {
    background-color: green !important;
  }

  .md-button.ct-yellow {
    background-color: #e29641 !important;
  }

  .pointer {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/registrationRequests/edit/index.vue